import { Box } from "@mui/material";
import React from "react";
export const Heading = ({ children }) => {
    return <Box sx={{ paddingBottom: 4 }}>{children}</Box>;
};
